import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.19_@babel+core@7.29.7_react-dom@19.2.7_react@19.2.7__react@19.2.7_sass@1.77.4/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["AdvantagesSection"] */ "/app/web/components/one-stop/sections/AdvantagesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ApplicationsSection"] */ "/app/web/components/one-stop/sections/ApplicationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BrandHighlightsSection"] */ "/app/web/components/one-stop/sections/BrandHighlightsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CategoriesGridSection"] */ "/app/web/components/one-stop/sections/CategoriesGridSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CtaSection"] */ "/app/web/components/one-stop/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroSection"] */ "/app/web/components/one-stop/sections/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HighlightShowcaseSection"] */ "/app/web/components/one-stop/sections/HighlightShowcaseSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OemOdmGuideSection"] */ "/app/web/components/one-stop/sections/OemOdmGuideSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductSeriesShowcaseSection"] */ "/app/web/components/one-stop/sections/ProductSeriesShowcaseSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PurchaseProcessSection"] */ "/app/web/components/one-stop/sections/PurchaseProcessSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrustSection"] */ "/app/web/components/one-stop/sections/TrustSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ValuePropositionSection"] */ "/app/web/components/one-stop/sections/ValuePropositionSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SeoKeywordProvider"] */ "/app/web/components/product-series/SeoKeywordProvider.tsx");
